import { PostgrestResponse } from '@supabase/supabase-js';
import { IVwProdutosEstoque } from '../../../types/views/IVwProdutosEstoque';
import { BaseMultiTenantService } from '../base/BaseMultiTenantService';

/**
 * View para produtos com estoque
 * Corresponde à view 'vw_produtos_estoque' no banco de dados
 */
export class ViewProdutosEstoque extends BaseMultiTenantService<IVwProdutosEstoque[]> {
     constructor() {
          super('vw_produtos_estoque', [], 'organizacao');
     }

     /**
      * Lista todos os produtos com informações de estoque
      */
     async getProdutosComEstoque(organizationId: number): Promise<PostgrestResponse<IVwProdutosEstoque[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .order('descricao');
     }

     /**
      * Produtos com estoque baixo
      */
     async getProdutosEstoqueBaixo(organizationId: number): Promise<PostgrestResponse<IVwProdutosEstoque[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('controle_estoque', true)
               .filter('quantidade_estoque', 'lte', 'estoque_minimo')
               .order('quantidade_estoque');
     }

     /**
      * Produtos disponíveis para venda
      */
     async getProdutosDisponiveis(organizationId: number): Promise<PostgrestResponse<IVwProdutosEstoque[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .or('controle_estoque.eq.false,quantidade_estoque.gt.0')
               .order('descricao');
     }

     /**
      * Produtos por categoria/NCM
      */
     async getProdutosPorNCM(organizationId: number, ncm: string): Promise<PostgrestResponse<IVwProdutosEstoque[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('ncm', ncm)
               .order('descricao');
     }

     /**
      * Produtos por faixa de preço
      */
     async getProdutosPorFaixaPreco(organizationId: number, precoMin: number, precoMax: number): Promise<PostgrestResponse<IVwProdutosEstoque[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .gte('valor', precoMin)
               .lte('valor', precoMax)
               .order('valor');
     }

     /**
      * Relatório de estoque
      */
     async getRelatorioEstoque(organizationId: number): Promise<PostgrestResponse<IVwProdutosEstoque[]>> {
          return await this.client
               .from(this.tableName)
               .select('*')
               .eq(this.organizationIdField, organizationId)
               .eq('controle_estoque', true)
               .order('quantidade_estoque');
     }

     /**
      * Valor total do estoque
      */
     async getValorTotalEstoque(organizationId: number): Promise<number> {
          const { data } = await this.client
               .from(this.tableName)
               .select('valor.sum()')
               .eq(this.organizationIdField, organizationId)
               .eq('controle_estoque', true);

          return data?.[0]?.sum || 0;
     }
}

export const viewProdutosEstoque = new ViewProdutosEstoque();
